import styled from "styled-components";
import * as React from "react";
import { fontSizes } from "healthex-common/sizes";
import { HXPage } from "./HXDesktopPage";
import { FlexColumn } from "./common.styles";
import Save from "@mui/icons-material/Save";
import { HXButton } from "./HXButton";
export const AccountSettingsViewParent = styled(HXPage) `
    font-size: ${fontSizes.STANDARD};
`;
export const ContentContainer = styled(FlexColumn) `
    padding: 24px 0px 40px 0px;
    gap: 40px;
    flex: 1 0 0;
`;
export const SaveButton = styled(HXButton).attrs({
    startIcon: React.createElement(Save),
    component: "label",
    children: "Save",
}) ``;
